<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
body {
  padding-right: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue